<template>
<div id="videoplayer">
    <video controls id="vidframe" src="http://video.tu-freiberg.de/getMedium/Default/88f88c1f0ad1fdf743079f777ace3b22.mp4"></video>
    <b-button @click="spring"></b-button>
</div>
</template>

<script>
export default {
    name: 'videoplayer',
    methods:{
        spring(){
            var vid  = document.getElementById("vidframe");
            vid.currentTime = 20;
        }
    }
  
}
</script>



// WEBPACK FOOTER //
// src/components/videoPlayer.vue